<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'advance-search-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <!-- Search trong Vb đến/ chờ xử lý- đã xử lý -->
    <template #body>
      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>
      <el-form :model="advanceSearchForm" label-position="right">
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Số ký hiệu" class="formItem">
              <el-input
                v-model="advanceSearchForm.docCode"
                size="medium"
                class=""
                placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Trích yếu" class="formItem">
              <el-input
                v-model="advanceSearchForm.quote"
                size="medium"
                class=""
                placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Nội dung văn bản" class="formItem">
              <el-input
                v-model="advanceSearchForm.fileContent"
                size="medium"
                class=""
                placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Độ khẩn:" class="formItem">
              <el-select
                clearable
                class="style-fullWidth"
                v-model="advanceSearchForm.priorityId"
                filterable
                placeholder="-"
                size="medium"
              >
                <el-option
                  v-for="item in priorities"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12" v-if="isVanThu">
          <el-col :span="24">
            <el-form-item label="Sổ văn bản" class="formItem">
              <el-select
                clearable
                filterable
                v-model="advanceSearchForm.bookId"
                size="medium"
                placeholder="-"
                class="style-fullWidth input-border__bottom input-border__radius__0"
              >
                <el-option
                  v-for="item in books"
                  :key="item.id"
                  :label="item.bookName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="14">
            <el-form-item label="Ngày văn bản" class="formItem">
              <el-date-picker
                v-model="docDateRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                @change="docDateRangeChanged"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Ngày chuyển" class="formItem labelWidth__auto">
              <el-date-picker
                v-model="sendTimeRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                @change="sendTimeRangeChanged"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="" class="formItem">
              <template #label>
                <span class="flex-row flex__left">
                  Đơn vị phát hành (bên trong) &nbsp;
                  <i
                    class="fas fa-cog advance-search color__cyan clickable"
                    @click="isOpenSelectDepartmentDialog = true"
                  ></i>
                </span>
              </template>
              <el-select
                filterable
                clearable
                v-model="advanceSearchForm.publisherId"
                size="medium"
                placeholder="-"
                class="style-fullWidth"
              >
                <el-option
                  v-for="item in receiveDepartments"
                  :label="item.deptName"
                  :key="item.id"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12" v-if="tenantCode === TENANT_CODE.VINATABA">
          <el-col :span="24">
            <el-form-item label="Nơi ban hành" class="formItem">
              <el-input
                v-model="advanceSearchForm.insidePublisherName"
                size="medium"
                class=""
                placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item class="formItem" label="Đơn vị phát hành (bên ngoài)">
              <el-input
                v-model="advanceSearchForm.outsidePublisherName"
                size="medium"
                class=""
                placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Loại văn bản" class="formItem">
              <el-select
                clearable
                filterable
                v-model="advanceSearchForm.docTypeId"
                size="medium"
                placeholder="-"
                class="style-fullWidth"
              >
                <el-option
                  v-for="item in docTypes"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
<!--        <el-row :gutter="12" v-if="isEnableSearchTdhvpDoc">-->
<!--          <el-col :span="24">-->
<!--            <br />-->
<!--            <el-link-->
<!--              icon="el-icon-search"-->
<!--              type="primary"-->
<!--              class="font-weight__regular "-->
<!--              @click="searchTdhvpDoc"-->
<!--            >-->
<!--              Tra cứu văn bản hệ thống Tự động hóa văn phòng cũ-->
<!--            </el-link>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <el-row :gutter="12" v-if="isEnableSearchLockedRole">
          <el-col :span="24">
            <br />
            <el-link
              icon="el-icon-search"
              type="primary"
              class="font-weight__regular "
              @click="searchLockedRoleDocIn"
            >
              Tra cứu các văn bản theo vai trò đã khóa
            </el-link>
          </el-col>
        </el-row>
        <vbden-sort-select @selectedSort="selectedSort" :form="form" ref="vbDenSortSelect"></vbden-sort-select>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Văn bản đến lãnh đạo" class="formItem">
              <el-checkbox  v-model="advanceSearchForm.docToLeader"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="search">
          <i class="fal fa-search font-size__small"></i>
          &nbsp;Tìm kiếm
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="reset"
        >Khởi tạo
        </el-button>

        <selectDepartmentDialog
          :isOpen="isOpenSelectDepartmentDialog"
          v-if="isEnableSelectDepartmentDialog"
          @closed="isEnableSelectDepartmentDialog = false"
          @closeDialog="isOpenSelectDepartmentDialog = false"
          @change="publisherDepartmentChange"
        >
        </selectDepartmentDialog>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
  import h from "../../../services/h";
  import constants from "../../../constants";
  import categoryViewService from "../../../services/categoryViewService";
  import departmentService from "../../../services/departmentService";
  import utils from "../../../services/utils";
  import bookService from "../../../services/bookService";
  import otherDepartmentService from "../../../services/otherDepartmentService";
  import dateUtils from "../../../dateUtils";
  import VbdenSortSelect from "../../common/vbden-sort-select";

  export default {
    name: "vbden-advance-search-dialog",
    props: ["isOpen", "form", "isEnableSearchTdhvpDoc","isEnableSearchLockedRole"],
    components: {
      VbdenSortSelect,
      customDialog: () => import("../../common/custom-dialog.vue"),
      selectDepartmentDialog: () =>
        import("../../common/commonSelectDepartmentDialog")
    },

    data() {
      return {
        sortList:[],
        priorities: [],
        insideReceiver: "",
        listInsideReceiver: [],
        isLoading: false,
        receiveDepartments: [],
        docDateRange: null,
        sendTimeRange: null,
        books: [],
        docTypes: [],
        departments: [],
        isOpenSelectDepartmentDialog: false,
        isEnableSelectDepartmentDialog: false,
        advanceSearchForm: {
          docCode: null,
          quote: null,
          fileContent: null,
          docTypeId: null,
          bookId: null,
          publisherId: null,
          priorityId:null,
          outsidePublisherName: null,
          insidePublisherName: null,
          fromDocDate: null,
          toDocDate: null,
          docToLeader: false
        },
        dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
        TENANT_CODE: constants.TENANT_CODE,
      };
    },

    computed: {
      tenantCode(){
        return this.$store.getters.userDeptRole.tenantCode;
      },
      deptId() {
        return this.$store.getters.userDeptRole.deptId;
      },
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      },
      isVanThu() {
        return (
          this.userDeptRole &&
          this.userDeptRole.roleCode === constants.ROLE.CODE.VAN_THU
        );
      }
    },

    watch: {
      isOpenSelectDepartmentDialog(newValue) {
        newValue && (this.isEnableSelectDepartmentDialog = newValue);
      }
    },

    mounted() {
      this.loadBooks();
      this.loadCategories();
      this.loadDepartments();
      this.initForm();
    },

    methods: {
      searchTdhvpDoc() {
        this.$emit("searchTdhvpDoc");
      },

      selectedSort(event){
        this.sortList=event.sortList;
      },

      searchLockedRoleDocIn() {
        this.$emit("searchLockedRoleDocIn");
      },
      initForm() {
        this.advanceSearchForm.docCode = this.form.docCode;
        this.advanceSearchForm.quote = this.form.quote;
        this.advanceSearchForm.fileContent = this.form.fileContent;
        this.advanceSearchForm.docTypeId = this.form.docTypeId;
        this.advanceSearchForm.bookId = this.form.bookId;
        this.advanceSearchForm.publisherId = this.form.publisherId;
        this.advanceSearchForm.priorityId = this.form.priorityId;
        this.advanceSearchForm.outsidePublisherName = this.form.outsidePublisherName;
        this.advanceSearchForm.insidePublisherName = this.form.insidePublisherName;
        this.advanceSearchForm.fromDocDate = this.form.fromDocDate;
        this.advanceSearchForm.toDocDate = this.form.toDocDate;
        this.advanceSearchForm.fromSendTime = this.form.fromSendTime;
        this.advanceSearchForm.fromSendTime = this.form.fromSendTime;
        this.advanceSearchForm.toSendTime = this.form.toSendTime;
        this.initDocDateRange();
        this.initSendTimeRange();
      },

      initDocDateRange() {
        if (this.advanceSearchForm.fromDocDate || this.advanceSearchForm.toDocDate) {
          this.docDateRange = [
            dateUtils.toMoment(this.advanceSearchForm.fromDocDate),
            dateUtils.toMoment(this.advanceSearchForm.toDocDate)
          ];
        } else {
          this.docDateRange = null;
        }
      },

      initSendTimeRange() {
        if (this.advanceSearchForm.fromSendTime || this.advanceSearchForm.toSendTime) {
          this.sendTimeRange = [
            dateUtils.toMoment(this.advanceSearchForm.fromSendTime),
            dateUtils.toMoment(this.advanceSearchForm.toSendTime)
          ];
        } else {
          this.sendTimeRange = null;
        }
      },

      docDateRangeChanged() {
        this.advanceSearchForm.fromDocDate =
          this.docDateRange && this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined;
        this.advanceSearchForm.toDocDate =
          this.docDateRange && this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined;
      },

      sendTimeRangeChanged() {
        this.advanceSearchForm.fromSendTime =
          this.sendTimeRange && this.sendTimeRange[0]
            ? this.sendTimeRange[0].getTime()
            : undefined;
        this.advanceSearchForm.toSendTime =
          this.sendTimeRange && this.sendTimeRange[1]
            ? this.sendTimeRange[1].getTime()
            : undefined;
      },

      remoteMethod(query) {
        if (query !== "") {
          this.findOtherDept(query);
        } else {
          this.options = [];
        }
      },

      findOtherDept(query) {
        this.isLoading = true;
        otherDepartmentService
          .search(query, this.deptId, {sort: "count,desc", page: 0, size: 20})
          .then(res => {
            this.listInsideReceiver = res.data;
            this.isLoading = false;
          });
      },

      prepareReceiveDepartments() {
        this.receiveDepartments = departmentService.prepareReceiveDepartments(
          this.deptId,
          this.departments
        );
      },

      loadBooks() {
        bookService
          .findAll(
            {
              bookType: constants.BOOK_TYPE.VB_DEN,
              vbBookStatus: constants.VB_BOOK.STATUS.ACTIVE
            },
            {page: 0, size: 100, sort: "bookName,asc"}
          )
          .then(response => (this.books = response.data));
      },

      publisherDepartmentChange(event) {
        let department = event.selectedDepartment;
        this.advanceSearchForm.publisherId = department ? department.id : null;
        this.isOpenSelectDepartmentDialog = false;
      },

      loadDepartments() {
        departmentService.findAll().then(response => {
          this.departments = response.data;
          this.prepareReceiveDepartments();
        });
      },

      loadCategories() {
        h.each([constants.CATEGORY_GROUP_CODE.PRIORITY,constants.CATEGORY_GROUP_CODE.DOC_TYPE], item => {
          categoryViewService
            .findAll(
              {groupCode: item},
              {sort: "order,asc", page: 0, size: 1000}
            )
            .then(response => {
              switch (item) {
                case constants.CATEGORY_GROUP_CODE.PRIORITY:
                  return (this.priorities = response.data);
                case constants.CATEGORY_GROUP_CODE.DOC_TYPE:
                  return (this.docTypes = response.data);
              }
            });
        });
      },

      search() {
        let advanceSearchForm = {
          docCode: utils.nvl(this.advanceSearchForm.docCode, undefined),
          quote: utils.nvl(this.advanceSearchForm.quote, undefined),
          fileContent: utils.nvl(this.advanceSearchForm.fileContent, undefined),
          docTypeId: utils.nvl(this.advanceSearchForm.docTypeId, undefined),
          bookId: utils.nvl(this.advanceSearchForm.bookId, undefined),
          publisherId: utils.nvl(this.advanceSearchForm.publisherId, undefined),
          priorityId: utils.nvl(this.advanceSearchForm.priorityId, undefined),
          outsidePublisherName: utils.nvl(
            this.advanceSearchForm.outsidePublisherName,
            undefined
          ),
          insidePublisherName: utils.nvl(
            this.advanceSearchForm.insidePublisherName,
            undefined
          ),
          fromDocDate: utils.nvl(this.advanceSearchForm.fromDocDate, undefined),
          toDocDate: utils.nvl(this.advanceSearchForm.toDocDate, undefined),
          fromSendTime: utils.nvl(this.advanceSearchForm.fromSendTime, undefined),
          toSendTime: utils.nvl(this.advanceSearchForm.toSendTime, undefined),
          docToLeader:this.advanceSearchForm.docToLeader
        };
        this.$emit("doSearch", {advanceSearchForm: advanceSearchForm,sortList:this.sortList});
        this.$emit("closeDialog");
      },

      reset() {
        this.advanceSearchForm.docCode = null;
        this.advanceSearchForm.quote = null;
        this.advanceSearchForm.fileContent = null;
        this.advanceSearchForm.docTypeId = null;
        this.advanceSearchForm.bookId = null;
        this.advanceSearchForm.publisherId = null;
        this.advanceSearchForm.priorityId = null;
        this.advanceSearchForm.outsidePublisherName = null;
        this.advanceSearchForm.insidePublisherName = null;
        this.advanceSearchForm.fromDocDate = null;
        this.advanceSearchForm.toDocDate = null;
        this.advanceSearchForm.fromSendTime = null;
        this.advanceSearchForm.toSendTime = null;
        this.initDocDateRange();
        this.initSendTimeRange();
        this.$refs.vbDenSortSelect.resetData();
        this.sortList=[];
      }
    }
  };
</script>

<style scoped>
  .form {
    padding: 12px 20px 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/vbden-advance-search-dialog.vue